import FeatureGates, {
	type CustomAttributes,
	type Identifiers,
} from '@atlaskit/feature-gate-js-client';
import { logException } from '@atlassian/atlassian-studio-observability';

import { featureGatesOptions } from '../use-initialise-feature-gates-client';

export async function updateUser(
	{
		atlassianAccountId,
		atlassianOrgId,
		tenantId,
		workspaceId,
	}: {
		atlassianAccountId: string;
		atlassianOrgId?: string;
		workspaceId?: string;
		tenantId?: string;
	},
	customAttributes?: CustomAttributes,
): Promise<void> {
	const identifiers: Identifiers = {
		atlassianAccountId,
	};
	if (atlassianOrgId) {
		identifiers.atlassianOrgId = atlassianOrgId;
	}
	if (tenantId) {
		identifiers.tenantId = tenantId;
	}
	if (workspaceId) {
		identifiers.studioWorkspaceId = workspaceId;
		// @TODO: Remove this when safe to do so (eg no Studio workspaceId targeted gates are left using `miscellaneousId`)
		identifiers.miscellaneousId = workspaceId;
	}

	try {
		await FeatureGates.updateUser(featureGatesOptions, identifiers, customAttributes);
	} catch (error) {
		logException(error, {
			identifiers,
			tag: 'FeatureGates.updateUser',
		});
	}
}
